// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("./role.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ListType$ReactHooksTemplate = require("../data_fields/listType.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var SelectBox$ReactHooksTemplate = require("../common/SelectBox.res.js");
var EmailInput$ReactHooksTemplate = require("../common/EmailInput.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");
var Notification$ReactHooksTemplate = require("../common/Notification.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var DataRestriction$ReactHooksTemplate = require("./dataRestriction.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function create(enabledOpt, role) {
  var enabled = enabledOpt !== undefined ? enabledOpt : false;
  return {
          role: role,
          enabled: enabled
        };
}

function role(t) {
  return t.role;
}

function roleId(t) {
  return Role$ReactHooksTemplate.id(t.role);
}

function enabled(t) {
  return t.enabled;
}

function toggleStatus(t) {
  return {
          role: t.role,
          enabled: !t.enabled
        };
}

var RoleStatus = {
  create: create,
  role: role,
  roleId: roleId,
  enabled: enabled,
  toggleStatus: toggleStatus
};

function create$1(idOpt, name, dataFieldOpt, _destroyOpt, showOptionsOpt, operator, value) {
  var id = idOpt !== undefined ? Caml_option.valFromOption(idOpt) : undefined;
  var dataField = dataFieldOpt !== undefined ? Caml_option.valFromOption(dataFieldOpt) : undefined;
  var _destroy = _destroyOpt !== undefined ? _destroyOpt : false;
  var showOptions = showOptionsOpt !== undefined ? showOptionsOpt : false;
  return {
          id: id,
          name: name,
          dataField: dataField,
          operator: operator,
          value: value,
          _destroy: _destroy,
          showOptions: showOptions
        };
}

var empty = {
  id: undefined,
  name: "Select Field",
  dataField: undefined,
  operator: "in",
  value: /* [] */0,
  _destroy: false,
  showOptions: false
};

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function name(t) {
  return t.name;
}

function dataField(t) {
  return t.dataField;
}

function operator(t) {
  return t.operator;
}

function _destroy(t) {
  return t._destroy;
}

function showOptions(t) {
  return t.showOptions;
}

var DataRestrictionCondition = {
  create: create$1,
  empty: empty,
  id: id,
  value: value,
  name: name,
  dataField: dataField,
  operator: operator,
  _destroy: _destroy,
  showOptions: showOptions
};

function reducer(state, action) {
  if (typeof state !== "object") {
    if (typeof action !== "object" || action.TAG !== "ShowAddNewUserForm") {
      return state;
    } else {
      return {
              TAG: "Available",
              _0: action._0
            };
    }
  }
  var formView = state._0;
  if (typeof action !== "object") {
    if (formView.TAG === "NewUser") {
      var userForm = formView._0;
      return {
              TAG: "Available",
              _0: {
                TAG: "NewUser",
                _0: {
                  id: userForm.id,
                  email: userForm.email,
                  emailAvailable: userForm.emailAvailable,
                  firstName: userForm.firstName,
                  lastName: userForm.lastName,
                  username: userForm.username,
                  usernameAvailable: userForm.usernameAvailable,
                  activeStatus: !userForm.activeStatus,
                  roleStatuses: userForm.roleStatuses,
                  dataRestrictionConditions: userForm.dataRestrictionConditions,
                  dataFields: userForm.dataFields
                }
              }
            };
    }
    var userForm$1 = formView._0;
    return {
            TAG: "Available",
            _0: {
              TAG: "EditUser",
              _0: {
                id: userForm$1.id,
                email: userForm$1.email,
                emailAvailable: userForm$1.emailAvailable,
                firstName: userForm$1.firstName,
                lastName: userForm$1.lastName,
                username: userForm$1.username,
                usernameAvailable: userForm$1.usernameAvailable,
                activeStatus: !userForm$1.activeStatus,
                roleStatuses: userForm$1.roleStatuses,
                dataRestrictionConditions: userForm$1.dataRestrictionConditions,
                dataFields: userForm$1.dataFields
              }
            }
          };
  }
  switch (action.TAG) {
    case "ShowAddNewUserForm" :
        return {
                TAG: "Available",
                _0: action._0
              };
    case "ChangeEmail" :
        var email = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$2 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$2.id,
                      email: email,
                      emailAvailable: userForm$2.emailAvailable,
                      firstName: userForm$2.firstName,
                      lastName: userForm$2.lastName,
                      username: userForm$2.username,
                      usernameAvailable: userForm$2.usernameAvailable,
                      activeStatus: userForm$2.activeStatus,
                      roleStatuses: userForm$2.roleStatuses,
                      dataRestrictionConditions: userForm$2.dataRestrictionConditions,
                      dataFields: userForm$2.dataFields
                    }
                  }
                };
        }
        var userForm$3 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$3.id,
                    email: email,
                    emailAvailable: userForm$3.emailAvailable,
                    firstName: userForm$3.firstName,
                    lastName: userForm$3.lastName,
                    username: userForm$3.username,
                    usernameAvailable: userForm$3.usernameAvailable,
                    activeStatus: userForm$3.activeStatus,
                    roleStatuses: userForm$3.roleStatuses,
                    dataRestrictionConditions: userForm$3.dataRestrictionConditions,
                    dataFields: userForm$3.dataFields
                  }
                }
              };
    case "ChangeEmailAvailability" :
        var emailAvailable = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$4 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$4.id,
                      email: userForm$4.email,
                      emailAvailable: emailAvailable,
                      firstName: userForm$4.firstName,
                      lastName: userForm$4.lastName,
                      username: userForm$4.username,
                      usernameAvailable: userForm$4.usernameAvailable,
                      activeStatus: userForm$4.activeStatus,
                      roleStatuses: userForm$4.roleStatuses,
                      dataRestrictionConditions: userForm$4.dataRestrictionConditions,
                      dataFields: userForm$4.dataFields
                    }
                  }
                };
        }
        var userForm$5 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$5.id,
                    email: userForm$5.email,
                    emailAvailable: emailAvailable,
                    firstName: userForm$5.firstName,
                    lastName: userForm$5.lastName,
                    username: userForm$5.username,
                    usernameAvailable: userForm$5.usernameAvailable,
                    activeStatus: userForm$5.activeStatus,
                    roleStatuses: userForm$5.roleStatuses,
                    dataRestrictionConditions: userForm$5.dataRestrictionConditions,
                    dataFields: userForm$5.dataFields
                  }
                }
              };
    case "ChangeFirstName" :
        var firstName = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$6 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$6.id,
                      email: userForm$6.email,
                      emailAvailable: userForm$6.emailAvailable,
                      firstName: firstName,
                      lastName: userForm$6.lastName,
                      username: userForm$6.username,
                      usernameAvailable: userForm$6.usernameAvailable,
                      activeStatus: userForm$6.activeStatus,
                      roleStatuses: userForm$6.roleStatuses,
                      dataRestrictionConditions: userForm$6.dataRestrictionConditions,
                      dataFields: userForm$6.dataFields
                    }
                  }
                };
        }
        var userForm$7 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$7.id,
                    email: userForm$7.email,
                    emailAvailable: userForm$7.emailAvailable,
                    firstName: firstName,
                    lastName: userForm$7.lastName,
                    username: userForm$7.username,
                    usernameAvailable: userForm$7.usernameAvailable,
                    activeStatus: userForm$7.activeStatus,
                    roleStatuses: userForm$7.roleStatuses,
                    dataRestrictionConditions: userForm$7.dataRestrictionConditions,
                    dataFields: userForm$7.dataFields
                  }
                }
              };
    case "ChangeLastName" :
        var lastName = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$8 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$8.id,
                      email: userForm$8.email,
                      emailAvailable: userForm$8.emailAvailable,
                      firstName: userForm$8.firstName,
                      lastName: lastName,
                      username: userForm$8.username,
                      usernameAvailable: userForm$8.usernameAvailable,
                      activeStatus: userForm$8.activeStatus,
                      roleStatuses: userForm$8.roleStatuses,
                      dataRestrictionConditions: userForm$8.dataRestrictionConditions,
                      dataFields: userForm$8.dataFields
                    }
                  }
                };
        }
        var userForm$9 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$9.id,
                    email: userForm$9.email,
                    emailAvailable: userForm$9.emailAvailable,
                    firstName: userForm$9.firstName,
                    lastName: lastName,
                    username: userForm$9.username,
                    usernameAvailable: userForm$9.usernameAvailable,
                    activeStatus: userForm$9.activeStatus,
                    roleStatuses: userForm$9.roleStatuses,
                    dataRestrictionConditions: userForm$9.dataRestrictionConditions,
                    dataFields: userForm$9.dataFields
                  }
                }
              };
    case "ChangeUserName" :
        var username = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$10 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$10.id,
                      email: userForm$10.email,
                      emailAvailable: userForm$10.emailAvailable,
                      firstName: userForm$10.firstName,
                      lastName: userForm$10.lastName,
                      username: username,
                      usernameAvailable: userForm$10.usernameAvailable,
                      activeStatus: userForm$10.activeStatus,
                      roleStatuses: userForm$10.roleStatuses,
                      dataRestrictionConditions: userForm$10.dataRestrictionConditions,
                      dataFields: userForm$10.dataFields
                    }
                  }
                };
        }
        var userForm$11 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$11.id,
                    email: userForm$11.email,
                    emailAvailable: userForm$11.emailAvailable,
                    firstName: userForm$11.firstName,
                    lastName: userForm$11.lastName,
                    username: username,
                    usernameAvailable: userForm$11.usernameAvailable,
                    activeStatus: userForm$11.activeStatus,
                    roleStatuses: userForm$11.roleStatuses,
                    dataRestrictionConditions: userForm$11.dataRestrictionConditions,
                    dataFields: userForm$11.dataFields
                  }
                }
              };
    case "ChangeUserNameAvailability" :
        var usernameAvailable = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$12 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$12.id,
                      email: userForm$12.email,
                      emailAvailable: userForm$12.emailAvailable,
                      firstName: userForm$12.firstName,
                      lastName: userForm$12.lastName,
                      username: userForm$12.username,
                      usernameAvailable: usernameAvailable,
                      activeStatus: userForm$12.activeStatus,
                      roleStatuses: userForm$12.roleStatuses,
                      dataRestrictionConditions: userForm$12.dataRestrictionConditions,
                      dataFields: userForm$12.dataFields
                    }
                  }
                };
        }
        var userForm$13 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$13.id,
                    email: userForm$13.email,
                    emailAvailable: userForm$13.emailAvailable,
                    firstName: userForm$13.firstName,
                    lastName: userForm$13.lastName,
                    username: userForm$13.username,
                    usernameAvailable: usernameAvailable,
                    activeStatus: userForm$13.activeStatus,
                    roleStatuses: userForm$13.roleStatuses,
                    dataRestrictionConditions: userForm$13.dataRestrictionConditions,
                    dataFields: userForm$13.dataFields
                  }
                }
              };
    case "ToggleRoleStatus" :
        var roleStatus = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$14 = formView._0;
          var roleStatuses = List.map((function (x) {
                  if (Caml_obj.equal(x, roleStatus)) {
                    return toggleStatus(x);
                  } else {
                    return x;
                  }
                }), userForm$14.roleStatuses);
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$14.id,
                      email: userForm$14.email,
                      emailAvailable: userForm$14.emailAvailable,
                      firstName: userForm$14.firstName,
                      lastName: userForm$14.lastName,
                      username: userForm$14.username,
                      usernameAvailable: userForm$14.usernameAvailable,
                      activeStatus: userForm$14.activeStatus,
                      roleStatuses: roleStatuses,
                      dataRestrictionConditions: userForm$14.dataRestrictionConditions,
                      dataFields: userForm$14.dataFields
                    }
                  }
                };
        }
        var userForm$15 = formView._0;
        var roleStatuses$1 = List.map((function (x) {
                if (Caml_obj.equal(x, roleStatus)) {
                  return toggleStatus(x);
                } else {
                  return x;
                }
              }), userForm$15.roleStatuses);
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$15.id,
                    email: userForm$15.email,
                    emailAvailable: userForm$15.emailAvailable,
                    firstName: userForm$15.firstName,
                    lastName: userForm$15.lastName,
                    username: userForm$15.username,
                    usernameAvailable: userForm$15.usernameAvailable,
                    activeStatus: userForm$15.activeStatus,
                    roleStatuses: roleStatuses$1,
                    dataRestrictionConditions: userForm$15.dataRestrictionConditions,
                    dataFields: userForm$15.dataFields
                  }
                }
              };
    case "AddDataRestrictionCondition" :
        var condition = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$16 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$16.id,
                      email: userForm$16.email,
                      emailAvailable: userForm$16.emailAvailable,
                      firstName: userForm$16.firstName,
                      lastName: userForm$16.lastName,
                      username: userForm$16.username,
                      usernameAvailable: userForm$16.usernameAvailable,
                      activeStatus: userForm$16.activeStatus,
                      roleStatuses: userForm$16.roleStatuses,
                      dataRestrictionConditions: List.append(userForm$16.dataRestrictionConditions, {
                            hd: condition,
                            tl: /* [] */0
                          }),
                      dataFields: userForm$16.dataFields
                    }
                  }
                };
        }
        var userForm$17 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$17.id,
                    email: userForm$17.email,
                    emailAvailable: userForm$17.emailAvailable,
                    firstName: userForm$17.firstName,
                    lastName: userForm$17.lastName,
                    username: userForm$17.username,
                    usernameAvailable: userForm$17.usernameAvailable,
                    activeStatus: userForm$17.activeStatus,
                    roleStatuses: userForm$17.roleStatuses,
                    dataRestrictionConditions: List.append(userForm$17.dataRestrictionConditions, {
                          hd: condition,
                          tl: /* [] */0
                        }),
                    dataFields: userForm$17.dataFields
                  }
                }
              };
    case "UpdateDataRestrictionConditions" :
        var dataRestrictionConditions = action._0;
        if (formView.TAG === "NewUser") {
          var userForm$18 = formView._0;
          return {
                  TAG: "Available",
                  _0: {
                    TAG: "NewUser",
                    _0: {
                      id: userForm$18.id,
                      email: userForm$18.email,
                      emailAvailable: userForm$18.emailAvailable,
                      firstName: userForm$18.firstName,
                      lastName: userForm$18.lastName,
                      username: userForm$18.username,
                      usernameAvailable: userForm$18.usernameAvailable,
                      activeStatus: userForm$18.activeStatus,
                      roleStatuses: userForm$18.roleStatuses,
                      dataRestrictionConditions: dataRestrictionConditions,
                      dataFields: userForm$18.dataFields
                    }
                  }
                };
        }
        var userForm$19 = formView._0;
        return {
                TAG: "Available",
                _0: {
                  TAG: "EditUser",
                  _0: {
                    id: userForm$19.id,
                    email: userForm$19.email,
                    emailAvailable: userForm$19.emailAvailable,
                    firstName: userForm$19.firstName,
                    lastName: userForm$19.lastName,
                    username: userForm$19.username,
                    usernameAvailable: userForm$19.usernameAvailable,
                    activeStatus: userForm$19.activeStatus,
                    roleStatuses: userForm$19.roleStatuses,
                    dataRestrictionConditions: dataRestrictionConditions,
                    dataFields: userForm$19.dataFields
                  }
                }
              };
    
  }
}

function isPasswordFilled(x) {
  return !Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.isEmpty, x);
}

function isEmailFilled(x) {
  return !Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, x);
}

function isPasswordValid(x) {
  if (isPasswordFilled(x)) {
    return Utils$ReactHooksTemplate.checkMinLength8(Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.show, x));
  } else {
    return true;
  }
}

function isAlphanumericPassword(x) {
  if (isPasswordFilled(x)) {
    return Utils$ReactHooksTemplate.checkAlphanumeric(Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.show, x));
  } else {
    return true;
  }
}

function isUserNameInPassword(email, x) {
  var emailInPwd = Utils$ReactHooksTemplate.checkUsernameExistInPassword(Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email), Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.show, x));
  if (isPasswordFilled(x) && isEmailFilled(email)) {
    return emailInPwd;
  } else {
    return false;
  }
}

function areIndpendentFieldsValid(formView) {
  return true;
}

function arePasswordsFilled(x, y) {
  if (isPasswordFilled(x)) {
    return isPasswordFilled(y);
  } else {
    return false;
  }
}

function arePasswordsExactMatch(x, y) {
  if (arePasswordsFilled(x, y)) {
    return Caml_obj.equal(x, y);
  } else {
    return true;
  }
}

function areDepedentFieldsValid(formView) {
  return true;
}

function hasEmail(form) {
  if (Caml_obj.notequal(form.email, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined))) {
    return form.emailAvailable;
  } else {
    return false;
  }
}

function hasFirstName(form) {
  return Caml_obj.notequal(form.firstName, Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined));
}

function hasLastName(form) {
  return Caml_obj.notequal(form.lastName, Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined));
}

function hasSomeRoleEnabled(form) {
  return Belt_List.some(form.roleStatuses, enabled);
}

function hasMandatoryParams(formView) {
  var userForm = formView._0;
  if (hasEmail(userForm) && hasFirstName(userForm) && hasLastName(userForm)) {
    return Belt_List.some(userForm.roleStatuses, enabled);
  } else {
    return false;
  }
}

function hasProfileParams(formView) {
  var userForm = formView._0;
  if (!Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.isEmpty, userForm.firstName) && !Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.isEmpty, userForm.lastName) && !Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.isEmpty, userForm.username)) {
    return userForm.usernameAvailable;
  } else {
    return false;
  }
}

function isFormValid(formView, profile) {
  if (profile) {
    if (hasProfileParams(formView)) {
      return true;
    } else {
      return false;
    }
  } else if (hasMandatoryParams(formView)) {
    return true;
  } else {
    return false;
  }
}

var emptyUser_email = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined);

var emptyUser_firstName = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined);

var emptyUser_lastName = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined);

var emptyUser_username = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined);

var emptyUser = {
  id: undefined,
  email: emptyUser_email,
  emailAvailable: true,
  firstName: emptyUser_firstName,
  lastName: emptyUser_lastName,
  username: emptyUser_username,
  usernameAvailable: true,
  activeStatus: false,
  roleStatuses: /* [] */0,
  dataRestrictionConditions: /* [] */0,
  dataFields: /* [] */0
};

function fetchRoles(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                return Json_decode.field("roles", (function (param) {
                              return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                            }), param);
              }));
}

function fetchDataFields(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                return Json_decode.field("data_fields", (function (param) {
                              return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                            }), param);
              }));
}

function buildUserDict(formView) {
  var params = {};
  var userForm = formView._0;
  params["email"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, userForm.email);
  params["username"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.username);
  params["first_name"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.firstName);
  params["last_name"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.lastName);
  params["active"] = userForm.activeStatus;
  params["role_ids"] = $$Array.of_list(List.map((function (prim) {
              return prim;
            }), List.map(roleId, List.filter(enabled)(userForm.roleStatuses))));
  var dataRestrictionAttributes = Belt_List.map(Belt_List.keep(userForm.dataRestrictionConditions, (function (x) {
              var match = x.dataField;
              var match$1 = x.value;
              if (match === undefined) {
                return false;
              }
              if (!match$1) {
                return false;
              }
              switch (match$1.hd) {
                case "" :
                case "Select Option" :
                    return false;
                default:
                  return true;
              }
            })), (function (x) {
          var attribute = {};
          var id = x.id;
          if (id !== undefined) {
            attribute["id"] = id;
            attribute["_destroy"] = x._destroy;
          }
          var dataField = x.dataField;
          if (dataField !== undefined) {
            attribute["data_field_id"] = Belt_Option.getExn(DataField$ReactHooksTemplate.id(Caml_option.valFromOption(dataField)));
            attribute["operator"] = x.operator;
            attribute["value"] = Json_encode.list((function (y) {
                    return y;
                  }), x.value);
          }
          return attribute;
        }));
  params["data_restrictions_attributes"] = $$Array.of_list(Belt_List.map(dataRestrictionAttributes, (function (prim) {
              return prim;
            })));
  var user = {};
  user["user"] = params;
  return user;
}

function createUser(formView) {
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users", buildUserDict(formView));
}

function updateUser(formView) {
  var id = formView._0.id;
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users/" + String(Belt_Option.getExn(id)) + "/update", buildUserDict(formView));
}

function buildProfileDict(formView) {
  var params = {};
  var userForm = formView._0;
  params["username"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.username);
  params["first_name"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.firstName);
  params["last_name"] = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.lastName);
  var user = {};
  user["user"] = params;
  return user;
}

function updateProfile(formView) {
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users/profile/update", buildProfileDict(formView));
}

function checkEmailAPI(email, userId) {
  var api = "/users/check_email?[user][email]=" + Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email);
  if (userId !== undefined) {
    return api + ("&[user][id]=" + String(userId));
  } else {
    return api;
  }
}

function checkUsernameAPI(username, userId) {
  var api = "/users/check_username?[user][username]=" + Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, username);
  if (userId !== undefined) {
    return api + ("&[user][id]=" + String(userId));
  } else {
    return api;
  }
}

function checkEmail(email, userId) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode(checkEmailAPI(email, userId), (function (param) {
                return Json_decode.field("available", Json_decode.bool, param);
              }));
}

function checkUsername(username, userId) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode(checkUsernameAPI(username, userId), (function (param) {
                return Json_decode.field("available", Json_decode.bool, param);
              }));
}

function editForm(formView) {
  if (formView.TAG === "NewUser") {
    return false;
  } else {
    return true;
  }
}

function decodeApiResponseStatus(response) {
  return Json_decode.field("status", Json_decode.string, response).toLowerCase();
}

function formatApiErrors(response) {
  try {
    var errorDict = Json_decode.field("errors", (function (param) {
            return Json_decode.dict((function (param) {
                          return Json_decode.list(Json_decode.string, param);
                        }), param);
          }), response);
    var messages = Belt_Array.map(Js_dict.values(errorDict), (function (messages) {
            return Belt_List.reduce(messages, "", (function (a, b) {
                          return a + " " + b;
                        }));
          }));
    return Belt_Array.reduce(messages, "", (function (acc, msg) {
                  if (acc === "") {
                    return msg;
                  } else {
                    return acc + " " + msg;
                  }
                }));
  }
  catch (exn){
    return "Unable to save profile. Please try again.";
  }
}

function UserForm(props) {
  var __profile = props.profile;
  var user = props.user;
  var profile = __profile !== undefined ? __profile : false;
  var initialFormView;
  if (user !== undefined) {
    var x = User$ReactHooksTemplate.username(user);
    initialFormView = {
      TAG: "EditUser",
      _0: {
        id: User$ReactHooksTemplate.id(user),
        email: User$ReactHooksTemplate.email(user),
        emailAvailable: true,
        firstName: User$ReactHooksTemplate.firstName(user),
        lastName: User$ReactHooksTemplate.lastName(user),
        username: x !== undefined ? Caml_option.valFromOption(x) : Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined),
        usernameAvailable: true,
        activeStatus: User$ReactHooksTemplate.active(user),
        roleStatuses: List.map((function (x) {
                return create(true, x);
              }), User$ReactHooksTemplate.roles(user)),
        dataRestrictionConditions: Belt_List.map(User$ReactHooksTemplate.dataRestrictions(user), (function (x) {
                return create$1(Caml_option.some(DataRestriction$ReactHooksTemplate.id(x)), DataField$ReactHooksTemplate.name(DataRestriction$ReactHooksTemplate.dataField(x)), Caml_option.some(Caml_option.some(DataRestriction$ReactHooksTemplate.dataField(x))), false, false, DataRestriction$ReactHooksTemplate.operator(x), DataRestriction$ReactHooksTemplate.value(x));
              })),
        dataFields: /* [] */0
      }
    };
  } else {
    initialFormView = {
      TAG: "NewUser",
      _0: emptyUser
    };
  }
  var match = React.useReducer(reducer, profile ? ({
            TAG: "Available",
            _0: initialFormView
          }) : "FetchRolesInProgress");
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setDataFields = match$1[1];
  var dataFields = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setNotification = match$2[1];
  var notification = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setSaving = match$3[1];
  var saving = match$3[0];
  React.useEffect((function (param) {
          if (profile) {
            return ;
          } else {
            Js_promise.then_((function (roles) {
                    var tmp;
                    if (initialFormView.TAG === "NewUser") {
                      var userForm = initialFormView._0;
                      var partial_arg = false;
                      tmp = {
                        TAG: "NewUser",
                        _0: {
                          id: userForm.id,
                          email: userForm.email,
                          emailAvailable: userForm.emailAvailable,
                          firstName: userForm.firstName,
                          lastName: userForm.lastName,
                          username: userForm.username,
                          usernameAvailable: userForm.usernameAvailable,
                          activeStatus: userForm.activeStatus,
                          roleStatuses: Belt_List.map(roles, (function (param) {
                                  return create(partial_arg, param);
                                })),
                          dataRestrictionConditions: userForm.dataRestrictionConditions,
                          dataFields: userForm.dataFields
                        }
                      };
                    } else {
                      var userForm$1 = initialFormView._0;
                      tmp = {
                        TAG: "EditUser",
                        _0: {
                          id: userForm$1.id,
                          email: userForm$1.email,
                          emailAvailable: userForm$1.emailAvailable,
                          firstName: userForm$1.firstName,
                          lastName: userForm$1.lastName,
                          username: userForm$1.username,
                          usernameAvailable: userForm$1.usernameAvailable,
                          activeStatus: userForm$1.activeStatus,
                          roleStatuses: Belt_List.map(roles, (function (role) {
                                  var enabled = Belt_List.length(Belt_List.keep(userForm$1.roleStatuses, (function (x) {
                                              return Role$ReactHooksTemplate.id(x.role) === Role$ReactHooksTemplate.id(role);
                                            }))) > 0;
                                  return create(enabled, role);
                                })),
                          dataRestrictionConditions: userForm$1.dataRestrictionConditions,
                          dataFields: userForm$1.dataFields
                        }
                      };
                    }
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "ShowAddNewUserForm",
                                    _0: tmp
                                  }));
                  }), fetchRoles());
            return ;
          }
        }), []);
  React.useEffect((function (param) {
          if (profile) {
            return ;
          } else {
            Js_promise.then_((function (dataFields) {
                    return Promise.resolve(Curry._1(setDataFields, (function (param) {
                                      return dataFields;
                                    })));
                  }), fetchDataFields());
            return ;
          }
        }), []);
  var handleFirstNameInput = function ($$event) {
    Utils$ReactHooksTemplate.handleInput(Utils$ReactHooksTemplate.checkMaxLength255, (function (x) {
            Curry._1(dispatch, {
                  TAG: "ChangeFirstName",
                  _0: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.create, x)
                });
          }), $$event);
  };
  var handleLastNameInput = function ($$event) {
    Utils$ReactHooksTemplate.handleInput(Utils$ReactHooksTemplate.checkMaxLength255, (function (x) {
            Curry._1(dispatch, {
                  TAG: "ChangeLastName",
                  _0: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.create, x)
                });
          }), $$event);
  };
  var addRestrictionCondition = function ($$event) {
    $$event.preventDefault();
    Curry._1(dispatch, {
          TAG: "AddDataRestrictionCondition",
          _0: empty
        });
  };
  var validCSS = "hidden";
  var emailAvailableCSS = function (form) {
    if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, form.email) || form.emailAvailable) {
      return validCSS;
    } else {
      return "text-red-600 font-medium";
    }
  };
  if (typeof state !== "object") {
    return JsxRuntime.jsx("p", {
                children: "Form is loading..."
              });
  }
  var formView = state._0;
  var userForm = formView._0;
  var pageTitle = profile ? "My Profile" : (
      editForm(formView) ? "Edit User" : "Add New User"
    );
  var tmp;
  if (profile) {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  } else {
    var options = List.map((function (x) {
            return Role$ReactHooksTemplate.name(x.role);
          }), userForm.roleStatuses);
    var roleEnabledRoles = List.find_all(function (y) {
            return y.enabled === true;
          })(userForm.roleStatuses);
    var roleNames = List.map((function (x) {
            return Role$ReactHooksTemplate.name(x.role);
          }), roleEnabledRoles);
    var partial_arg = userForm.roleStatuses;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("p", {
                                  children: "Roles",
                                  className: "text-sm font-medium mb-20-px"
                                }),
                            JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                  options: options,
                                  placeholder: "Select Options",
                                  handleChange: (function (param) {
                                      var selectedRole = List.hd(List.filter(function (y) {
                                                  return Role$ReactHooksTemplate.name(y.role) === param;
                                                })(partial_arg));
                                      return Curry._1(dispatch, {
                                                  TAG: "ToggleRoleStatus",
                                                  _0: selectedRole
                                                });
                                    }),
                                  selectedOptions: roleNames,
                                  className: "outline-none border border-gray-400 min-h-38-px rounded px-3 py-2 text-lg ",
                                  optionsHoverColor: "hover:bg-gray-300"
                                })
                          ],
                          className: "mb-30-px"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                checked: userForm.activeStatus,
                                label: "Active",
                                handleChange: (function (_evt) {
                                    Curry._1(dispatch, "ToggleActiveStatus");
                                  }),
                                checkboxClassName: "custom_checkbox",
                                labelClassName: "flex items-center"
                              }),
                          className: "flex items-center w-1/2 p-1"
                        })
                  ],
                  className: "block items-top mb-30-px w-5/11"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: "Data Restrictions: ",
                                className: "font-semibold mb-5"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  $$Array.of_list(Belt_List.mapWithIndex(userForm.dataRestrictionConditions, (function (index, x) {
                                              if (x._destroy) {
                                                return JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                              }
                                              var dataField = x.dataField;
                                              var tmp;
                                              if (dataField !== undefined) {
                                                var dataField$1 = Caml_option.valFromOption(dataField);
                                                tmp = JsxRuntime.jsx("option", {
                                                      children: DataField$ReactHooksTemplate.name(dataField$1),
                                                      value: String(Belt_Option.getExn(DataField$ReactHooksTemplate.id(dataField$1)))
                                                    }, DataField$ReactHooksTemplate.name(dataField$1));
                                              } else {
                                                tmp = JsxRuntime.jsx("option", {
                                                      children: "Select Field",
                                                      value: "0"
                                                    }, "0");
                                              }
                                              var dataField$2 = x.dataField;
                                              var partial_arg = userForm.dataRestrictionConditions;
                                              var dataField$3 = x.dataField;
                                              var options;
                                              if (dataField$3 !== undefined) {
                                                var listType = DataField$ReactHooksTemplate.dataType(Caml_option.valFromOption(dataField$3));
                                                options = listType.TAG === "ListType" ? ListType$ReactHooksTemplate.options(listType._0) : /* [] */0;
                                              } else {
                                                options = /* [] */0;
                                              }
                                              var partial_arg$1 = userForm.dataRestrictionConditions;
                                              var partial_arg$2 = userForm.dataRestrictionConditions;
                                              return JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: JsxRuntime.jsxs("select", {
                                                                        children: [
                                                                          tmp,
                                                                          $$Array.of_list(Belt_List.map(Belt_List.keep(Belt_List.keep(dataFields, (function (x) {
                                                                                              var match = DataField$ReactHooksTemplate.dataType(x);
                                                                                              if (match.TAG === "ListType") {
                                                                                                return true;
                                                                                              } else {
                                                                                                return false;
                                                                                              }
                                                                                            })), (function (x) {
                                                                                          var addedDataFields = Belt_List.keepMap(Belt_List.map(userForm.dataRestrictionConditions, (function (x) {
                                                                                                      return x.dataField;
                                                                                                    })), (function (x) {
                                                                                                  return x;
                                                                                                }));
                                                                                          return !List.exists((function (y) {
                                                                                                        return Caml_obj.equal(x, y);
                                                                                                      }), addedDataFields);
                                                                                        })), (function (x) {
                                                                                      return JsxRuntime.jsx("option", {
                                                                                                  children: DataField$ReactHooksTemplate.name(x),
                                                                                                  value: String(Belt_Option.getExn(DataField$ReactHooksTemplate.id(x)))
                                                                                                }, DataField$ReactHooksTemplate.name(x));
                                                                                    })))
                                                                        ],
                                                                        className: "border pl-1 cursor-pointer",
                                                                        placeholder: "Select field",
                                                                        value: dataField$2 !== undefined ? String(Belt_Option.getExn(DataField$ReactHooksTemplate.id(Caml_option.valFromOption(dataField$2)))) : "Select field",
                                                                        onChange: (function (param) {
                                                                            var dataFieldId = param.target.value;
                                                                            var dataField = List.filter(function (y) {
                                                                                    return String(Belt_Option.getExn(DataField$ReactHooksTemplate.id(y))) === dataFieldId;
                                                                                  })(dataFields);
                                                                            var conditions = Belt_List.mapWithIndex(partial_arg, (function (i, x) {
                                                                                    if (index !== i) {
                                                                                      return x;
                                                                                    }
                                                                                    if (!dataField) {
                                                                                      return x;
                                                                                    }
                                                                                    var head = dataField.hd;
                                                                                    return {
                                                                                            id: x.id,
                                                                                            name: DataField$ReactHooksTemplate.name(head),
                                                                                            dataField: Caml_option.some(head),
                                                                                            operator: x.operator,
                                                                                            value: /* [] */0,
                                                                                            _destroy: x._destroy,
                                                                                            showOptions: x.showOptions
                                                                                          };
                                                                                  }));
                                                                            return Curry._1(dispatch, {
                                                                                        TAG: "UpdateDataRestrictionConditions",
                                                                                        _0: conditions
                                                                                      });
                                                                          })
                                                                      }),
                                                                  className: "w-2/6"
                                                                }),
                                                            JsxRuntime.jsx(SelectBox$ReactHooksTemplate.make, {
                                                                  options: options,
                                                                  placeholder: "Select Options",
                                                                  handleChange: (function (param) {
                                                                      var conditions = Belt_List.mapWithIndex(partial_arg$1, (function (i, x) {
                                                                              if (index === i) {
                                                                                return {
                                                                                        id: x.id,
                                                                                        name: x.name,
                                                                                        dataField: x.dataField,
                                                                                        operator: x.operator,
                                                                                        value: param,
                                                                                        _destroy: x._destroy,
                                                                                        showOptions: x.showOptions
                                                                                      };
                                                                              } else {
                                                                                return x;
                                                                              }
                                                                            }));
                                                                      return Curry._1(dispatch, {
                                                                                  TAG: "UpdateDataRestrictionConditions",
                                                                                  _0: conditions
                                                                                });
                                                                    }),
                                                                  selectedOptions: x.value,
                                                                  className: "w-3/6 cursor-pointer "
                                                                }),
                                                            JsxRuntime.jsx("div", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: "Remove",
                                                                        className: "px-2 text-blue-800 text-xs\n                             font-extrabold cursor-pointer underline",
                                                                        onClick: (function (param) {
                                                                            param.preventDefault();
                                                                            var conditionToRemove = Belt_List.get(partial_arg$2, index);
                                                                            var conditions;
                                                                            if (conditionToRemove !== undefined) {
                                                                              var match = conditionToRemove.id;
                                                                              conditions = match !== undefined ? Belt_List.mapWithIndex(partial_arg$2, (function (i, x) {
                                                                                        if (i === index) {
                                                                                          return {
                                                                                                  id: x.id,
                                                                                                  name: x.name,
                                                                                                  dataField: x.dataField,
                                                                                                  operator: x.operator,
                                                                                                  value: x.value,
                                                                                                  _destroy: true,
                                                                                                  showOptions: x.showOptions
                                                                                                };
                                                                                        } else {
                                                                                          return x;
                                                                                        }
                                                                                      })) : Belt_List.keepWithIndex(partial_arg$2, (function (param, i) {
                                                                                        return i !== index;
                                                                                      }));
                                                                            } else {
                                                                              conditions = partial_arg$2;
                                                                            }
                                                                            return Curry._1(dispatch, {
                                                                                        TAG: "UpdateDataRestrictionConditions",
                                                                                        _0: conditions
                                                                                      });
                                                                          })
                                                                      }),
                                                                  className: "w-1/6"
                                                                })
                                                          ],
                                                          className: "flex items-center justify-between h-5 mb-5"
                                                        }, String(index));
                                            }))),
                                  JsxRuntime.jsx("a", {
                                        children: "+Add new condition",
                                        className: "text-blue-800 text-xs font-extrabold cursor-pointer\n                underline",
                                        onClick: addRestrictionCondition
                                      })
                                ],
                                className: ""
                              })
                        ],
                        className: "w-full"
                      }),
                  className: "flex mb-30-px items-center"
                })
          ]
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                notification !== undefined ? JsxRuntime.jsx(Notification$ReactHooksTemplate.make, {
                        text: notification[0],
                        isError: notification[1],
                        handleClose: (function (param) {
                            Curry._1(setNotification, (function (param) {
                                    
                                  }));
                          })
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("h1", {
                            children: pageTitle,
                            className: "text-xl font-semibold text-charcoal"
                          }),
                      className: "flex justify-between items-center border-b border-gray-300 px-30-px py-16-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(EmailInput$ReactHooksTemplate.make, {
                                                  email: userForm.email,
                                                  label: "Email",
                                                  handleChange: (function (param) {
                                                      return Utils$ReactHooksTemplate.handleInput(Utils$ReactHooksTemplate.checkMaxLength255, (function (x) {
                                                                    var email = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, x);
                                                                    Js_promise.then_((function (available) {
                                                                            return Promise.resolve(Curry._1(dispatch, {
                                                                                            TAG: "ChangeEmailAvailability",
                                                                                            _0: available
                                                                                          }));
                                                                          }), checkEmail(email, userForm.id));
                                                                    Curry._1(dispatch, {
                                                                          TAG: "ChangeEmail",
                                                                          _0: email
                                                                        });
                                                                  }), param);
                                                    }),
                                                  errorCSS: emailAvailableCSS(userForm),
                                                  errorText: "Email is already taken",
                                                  emailInputClassName: "outline-none border border-gray-400 max-h-44-px w-10/12 rounded px-3 py-2 text-lg",
                                                  emailLabelClassName: "text-sm font-medium mb-20-px",
                                                  readOnly: editForm(formView)
                                                }),
                                            className: "mb-30-px"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                  label: "Username",
                                                  value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.username),
                                                  handleChange: (function (param) {
                                                      return Utils$ReactHooksTemplate.handleInput(Utils$ReactHooksTemplate.checkMaxLength255, (function (x) {
                                                                    var username = Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.create, x);
                                                                    Js_promise.then_((function (available) {
                                                                            return Promise.resolve(Curry._1(dispatch, {
                                                                                            TAG: "ChangeUserNameAvailability",
                                                                                            _0: available
                                                                                          }));
                                                                          }), checkUsername(username, userForm.id));
                                                                    Curry._1(dispatch, {
                                                                          TAG: "ChangeUserName",
                                                                          _0: username
                                                                        });
                                                                  }), param);
                                                    }),
                                                  errorText: "Username is already taken",
                                                  error: !(Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.isEmpty, userForm.username) || userForm.usernameAvailable),
                                                  textInputClassName: "outline-none border border-gray-400 max-h-12 rounded px-3 py-2 text-lg",
                                                  containerClassName: "block mb-30-px",
                                                  labelClassName: "mb-20-px",
                                                  inputBoxContainerCss: "flex flex-col w-10/12"
                                                }),
                                            className: "mb-30-px"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                  label: "First Name",
                                                  value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.firstName),
                                                  handleChange: handleFirstNameInput,
                                                  textInputClassName: "outline-none border border-gray-400 max-h-12 rounded px-3 py-2 text-lg",
                                                  containerClassName: "block mb-30-px",
                                                  labelClassName: "mb-20-px",
                                                  inputBoxContainerCss: "flex flex-col w-10/12"
                                                }),
                                            className: "mb-30-px"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                  label: "Last Name",
                                                  value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, userForm.lastName),
                                                  handleChange: handleLastNameInput,
                                                  textInputClassName: "outline-none border border-gray-400 max-h-12 rounded px-3 py-2 text-lg",
                                                  containerClassName: "block mb-30-px",
                                                  labelClassName: "mb-20-px",
                                                  inputBoxContainerCss: "flex flex-col w-10/12"
                                                }),
                                            className: "mb-30-px"
                                          })
                                    ],
                                    className: "block mb-30-px w-6/11"
                                  }),
                              tmp,
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      profile ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("a", {
                                              children: "Cancel",
                                              className: "bg-white ml-4 px-5 py-3 rounded border border-bg-black hover:text-pigmentblue hover:border-pigmentblue text-black font-16px",
                                              href: "/users/all"
                                            }),
                                      JsxRuntime.jsx("input", {
                                            className: "bg-pigmentblue rounded hover:bg-cetaceanblue ml-4 px-6 py-3 font-normal\n                         text-white font-16-px leading-snug " + (
                                              !isFormValid(formView, profile) || saving ? " cursor-not-allowed " : " cursor-pointer "
                                            ),
                                            disabled: !isFormValid(formView, profile) || saving,
                                            type: "submit",
                                            value: profile ? (
                                                saving ? "Saving..." : "Save Profile"
                                              ) : (
                                                editForm(formView) ? "Update" : "Create"
                                              )
                                          })
                                    ]
                                  })
                            ],
                            onSubmit: (function (param) {
                                param.preventDefault();
                                var submitRequest = profile ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users/profile/update", buildProfileDict(formView)) : (
                                    editForm(formView) ? updateUser(formView) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users", buildUserDict(formView))
                                  );
                                Curry._1(setSaving, (function (param) {
                                        return true;
                                      }));
                                Js_promise.$$catch((function (param) {
                                        if (profile) {
                                          Curry._1(setNotification, (function (param) {
                                                  return [
                                                          "Network error while saving profile.",
                                                          true
                                                        ];
                                                }));
                                          Curry._1(setSaving, (function (param) {
                                                  return false;
                                                }));
                                        }
                                        return Promise.resolve();
                                      }), Js_promise.then_((function (param) {
                                            if (profile) {
                                              return Promise.resolve();
                                            } else {
                                              return Promise.resolve(RescriptReactRouter.push("/users/all"));
                                            }
                                          }), Js_promise.then_((function (response) {
                                                var status = decodeApiResponseStatus(response);
                                                if (profile) {
                                                  if (status === "success") {
                                                    Curry._1(setNotification, (function (param) {
                                                            return [
                                                                    "Profile updated successfully.",
                                                                    false
                                                                  ];
                                                          }));
                                                  } else {
                                                    Curry._1(setNotification, (function (param) {
                                                            return [
                                                                    formatApiErrors(response),
                                                                    true
                                                                  ];
                                                          }));
                                                  }
                                                  Curry._1(setSaving, (function (param) {
                                                          return false;
                                                        }));
                                                } else {
                                                  console.log(response);
                                                }
                                                return Promise.resolve();
                                              }), submitRequest)));
                              })
                          }),
                      className: "m-50-px w-2/3 bg-white"
                    })
              ]
            });
}

var make = UserForm;

exports.RoleStatus = RoleStatus;
exports.DataRestrictionCondition = DataRestrictionCondition;
exports.reducer = reducer;
exports.isPasswordFilled = isPasswordFilled;
exports.isEmailFilled = isEmailFilled;
exports.isPasswordValid = isPasswordValid;
exports.isAlphanumericPassword = isAlphanumericPassword;
exports.isUserNameInPassword = isUserNameInPassword;
exports.areIndpendentFieldsValid = areIndpendentFieldsValid;
exports.arePasswordsFilled = arePasswordsFilled;
exports.arePasswordsExactMatch = arePasswordsExactMatch;
exports.areDepedentFieldsValid = areDepedentFieldsValid;
exports.hasEmail = hasEmail;
exports.hasFirstName = hasFirstName;
exports.hasLastName = hasLastName;
exports.hasSomeRoleEnabled = hasSomeRoleEnabled;
exports.hasMandatoryParams = hasMandatoryParams;
exports.hasProfileParams = hasProfileParams;
exports.isFormValid = isFormValid;
exports.emptyUser = emptyUser;
exports.fetchRoles = fetchRoles;
exports.fetchDataFields = fetchDataFields;
exports.buildUserDict = buildUserDict;
exports.createUser = createUser;
exports.updateUser = updateUser;
exports.buildProfileDict = buildProfileDict;
exports.updateProfile = updateProfile;
exports.checkEmailAPI = checkEmailAPI;
exports.checkUsernameAPI = checkUsernameAPI;
exports.checkEmail = checkEmail;
exports.checkUsername = checkUsername;
exports.editForm = editForm;
exports.decodeApiResponseStatus = decodeApiResponseStatus;
exports.formatApiErrors = formatApiErrors;
exports.make = make;
/* emptyUser Not a pure module */
